import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
    cilX,

  cibCcAmex,
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilSun,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilTrash,
    cilApplications,
    cilListRich,
    cilPrint,
    cilTransfer,
    cilShare,
    cilHttps,
    cilChart,
    cilXCircle,
    cilLibrary,
cilChevronCircleUpAlt,
    cilBarcode,
    cilTruck,
    cilArrowThickBottom,
    cilMinus,
    cilMap,
    cilSave,
    cilBolt,
cilCheckAlt,
cilZoom,
cilCart,
    cilInfo,
    cilArrowLeft,
    cilSaveNew,
    cilCommentBubble,
cilPlus,
    cilBook,
    cilChartLine,
} from '@coreui/icons'

import {saveNew} from './customIcons'
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  {
      cilMap,
      cilChevronCircleUpAlt,
      cilTruck,
      cilPlus,
      cilArrowThickBottom,
      cilMinus,

    cilBarcode,
    cilLibrary,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilSun,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
      cilX,

      cilXCircle,
      cifUs,
      cifBr,
      cifIn,
      cifFr,
      cifEs,
      cifPl,

      cibFacebook,
      cibTwitter,
      cibLinkedin,
      cibFlickr,
      cibTumblr,
      cibXing,
      cibGithub,
      cibStackoverflow,
      cibYoutube,
      cibDribbble,
      cibInstagram,
      cibPinterest,
      cibVk,
      cibYahoo,
      cilTrash,
      cilChart,
      cilApplications,
      cilListRich,
      cilPrint,
      cilShare,
      cilHttps,
      cilTransfer,
      cibBehance,
      cibReddit,
      cibVimeo,
      cibCcMastercard,
      cibCcVisa,
      cibStripe,
      cibPaypal,
      cibGooglePay,
      cilSave,
      cilBolt,
      cilCheckAlt,
      cilZoom,
      cilSaveNew,
      cilCart,
      cilArrowLeft,
      cilChartLine,
      cilBook,
cilInfo,
      cilCommentBubble,
      saveNew,
      cibCcAmex

  }
)
